module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-34.47c42d66.png";